export interface IUploadFilesResponse {
    data: any;
}

export enum IUploadResponseStatus {
    ERROR = "ERROR",
    SUCCESS = "SUCCESS",
}
